import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import classNames from "classnames";
import React, { useContext } from "react";
import { getLink, getLinkTitle } from "../components/Blocks";
import { NavigationContext } from "../contexts/NavigationContext";
import { ContactInformation } from "./ContactInformation";
import { ExternalLinkSelection } from "./ExternalLinkSelection";
import { LanguageChooser } from "./LanguageChooser";
import { Separator } from "./Separator";

export const NavigationDrawerMobile: React.FC<{
  corePath: string;
  logo?: IGatsbySvg;
  navigation: Queries.MainNavigationFragment;
}> = (props) => {
  const {
    corePath,
    logo,
    navigation: { contactInformation, pageLinks, externalLinkSelection },
  } = props;
  const { isNavigationOpen, closeNavigation } = useContext(NavigationContext);

  return (
    <div
      data-component="Naviation drawer mobile"
      className={classNames(
        "wbond-full fixed bottom-0 left-0 top-0 z-40 transform overflow-y-auto bg-hyacinth pb-48px transition",
        isNavigationOpen ? "translate-x-0" : "translate-x-[100vw]"
      )}
    >
      <div className="page-grid">
        {logo && (
          <Link
            to={"/"}
            aria-label="Home"
            className={classNames("col-start-2", "col-span-3", "mt-30px")}
            onClick={closeNavigation}
          >
            <img
              src={logo.encoded ?? logo.encodedUrl}
              alt="Logo"
              width="246.25px"
              height="79.28px"
              loading="lazy"
            />
          </Link>
        )}
        <ul
          className={classNames(
            "col-start-3",
            "col-span-3",
            "text-cotton",
            "mt-50px"
          )}
        >
          {pageLinks?.map((pageLink, i) => {
            return (
              <li key={i} className={classNames("h2", "mb-48px")}>
                <Link to={getLink(pageLink)} onClick={closeNavigation}>
                  {getLinkTitle(pageLink)}
                </Link>
              </li>
            );
          })}
        </ul>
        <Separator
          className={classNames("col-start-2", "col-span-4", "my-48px")}
          colorClass={"text-cotton"}
        />
        {contactInformation && (
          <div className={classNames("col-start-2", "col-span-2")}>
            <ContactInformation information={contactInformation} />
          </div>
        )}
        {externalLinkSelection && (
          <div className={classNames("col-start-4", "col-span-2")}>
            <ExternalLinkSelection
              onClick={closeNavigation}
              links={externalLinkSelection.externalLinks}
            />
          </div>
        )}
        <div className="col-span-2 col-start-2">
          <LanguageChooser corePath={corePath} onClick={closeNavigation} />
        </div>
      </div>
    </div>
  );
};
